import {
  ApiRoute,
  CheckInTicket,
  PageData,
  PageDataSchema,
  Ticket,
  TicketDetail,
  TicketDetailSchema,
  TicketQuery,
  TicketSchema,
  getApiRoute
} from "@garther/interfaces";

import { ApiClientConfig, BaseApiClient } from "./base-client";

export class TicketApiClient extends BaseApiClient {
  constructor(config: ApiClientConfig) {
    super({
      ...config,
      baseEndpoint: getApiRoute(ApiRoute.TICKET),
      requireAuth: true
    });
  }

  async getList(params: TicketQuery = { limit: 20, page: 1 }): Promise<PageData<Ticket>> {
    return await this.get("", PageDataSchema(TicketSchema), {
      params,
      requireAuth: true
    });
  }

  async getTicketById(ticketId: string): Promise<TicketDetail> {
    return await this.get(ticketId, TicketDetailSchema, {
      requireAuth: true
    });
  }

  async checkIn(data: CheckInTicket): Promise<Ticket> {
    return await this.post("check-in", TicketSchema, data, {
      requireAuth: true
    });
  }
}
